import { Badge, Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import "./style.scss";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/JuanBecchio.jpg";
import SnakeGame from "./SnakeGame";
import SeccionMusica from "./Secciones/Musica";
import SeccionJuegos from "./Secciones/Juegos";

const JuanBecchio: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <div className='border-bottom mb-2 text-center'>
        <div className='border-bottom mb-2 d-flex flex-row align-items-center justify-content-center'>
          <h1>Juan Bautista Becchio</h1>
          <img
            className='rounded-circle m-4'
            width={92}
            alt='Foto de perfil de Juan Becchio'
            height={92}
            src={ProfilePicture}
          />
          <h3 className='text-muted'>Mobile Developer</h3>
        </div>
        <p>
          Bienvenido a mi perfil. Por este lado está la descripcion vaga, por
          este otro una copia del perfil de Fran
        </p>
      </div>
      <div className='mt-4 text-center'>
        <h4>Algunos de mis gustos:</h4>
        <p>
          Me gustan los jueguitos, la programación y la informática en
          general... pero eso no significa que puedo arreglarte la compu (o
          si?).
          <br />
          Me gusta escuchar música y por ahí tambien hago música fea. <br />
        </p>
      </div>
      <div className='devprofile-extra'>
        <SeccionMusica />
        <SeccionJuegos />
      </div>
      <SnakeGame startTickVelocity={125} />
      <p>
        Algunas de las tecnologías que manejo son{" "}
        <Badge className='mr-1' variant='info'>
          javascript
        </Badge>
        <Badge className='mr-1' variant='warning'>
          react-native
        </Badge>
        <Badge className='mr-1' variant='primary'>
          c#
        </Badge>
        <Badge className='mr-1' variant='danger'>
          unity
        </Badge>
      </p>
      <small>No te vayas sin apretar la R</small>
    </Container>
  );
};

export default new Content({
  Component: JuanBecchio,
  title: "Juan Becchio",
  route: "juan-becchio",
  tags: [
    "mobile",
    "node",
    "nodejs",
    "react",
    "react-native",
    "android",
    "ios",
    "npm",
    "javascript",
    "unity"
  ]
});
